// CODE FOR UNITS SOLD BADGE

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-units-sold]').forEach((el) => {
    const value = Number(el.dataset.unitsSold);
    el.textContent = value.toLocaleString('en-US');
  });
});

// CODE FOR BENEFITS BADGES ON PDP

document.addEventListener('DOMContentLoaded', () => {
  const benefits = document.querySelector('[data-product-benefits]');

  if (!benefits) return;

  const drawer = benefits.querySelector('.product-benefits__drawer');
  const triggers = benefits.querySelectorAll('[data-benefit-trigger]');

  // Move the drawer outside the PDP's three-column layout so it can
  // overlay the full page rather than sit underneath the Specifications column.
  document.body.appendChild(drawer);

  const closeButtons = drawer.querySelectorAll('[data-benefit-close]');
  const contentPanels = drawer.querySelectorAll('[data-benefit-content]');
  const closeButton = drawer.querySelector('.product-benefits__close');

  let activeTrigger = null;

  const openDrawer = (benefit, trigger) => {
    activeTrigger = trigger;

    contentPanels.forEach((panel) => {
      panel.hidden = panel.dataset.benefitContent !== benefit;
    });

    triggers.forEach((button) => {
      button.setAttribute(
        'aria-expanded',
        button === trigger ? 'true' : 'false'
      );
    });

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('product-benefits-open');

    window.setTimeout(() => closeButton.focus(), 300);
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('product-benefits-open');

    triggers.forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });

    if (activeTrigger) {
      activeTrigger.focus();
    }
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      openDrawer(trigger.dataset.benefitTrigger, trigger);
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });
});

// CODE FOR PCFITMENT COMPATABILITY CHART, RENAME TABLE HEADERS

  (() => {
    const labelMap = {
      BodyNumDoors: 'Doors',
      BodyType: 'Body Type'
    };

    let observer;

    const renameFitmentLabels = (root) => {
      if (!root) return;

      const textWalker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT
      );

      const textNodes = [];

      while (textWalker.nextNode()) {
        textNodes.push(textWalker.currentNode);
      }

      textNodes.forEach((textNode) => {
        const originalLabel = textNode.nodeValue.trim();

        if (labelMap[originalLabel]) {
          textNode.nodeValue = textNode.nodeValue.replace(
            originalLabel,
            labelMap[originalLabel]
          );
        }
      });
    };

    const initializeFitmentLabelRenaming = () => {
      const fitmentChart =
        document.querySelector('#Applications') ||
        document.querySelector('#fitmentApplicationsWrapper') ||
        document.querySelector('#bc-applications');

      if (!fitmentChart) return false;

      renameFitmentLabels(fitmentChart);

      if (observer) observer.disconnect();

      observer = new MutationObserver(() => {
        renameFitmentLabels(fitmentChart);
      });

      observer.observe(fitmentChart, {
        childList: true,
        subtree: true
      });

      return true;
    };

    document.addEventListener('DOMContentLoaded', () => {
      if (initializeFitmentLabelRenaming()) return;

      const pageObserver = new MutationObserver(() => {
        if (initializeFitmentLabelRenaming()) {
          pageObserver.disconnect();
        }
      });

      pageObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  })();

// CODE FOR PCFITMENT COMPATABILITY CHART ON MOBILE

(() => {
  const labelMap = {
    BodyNumDoors: 'Doors',
    BodyType: 'Body Type'
  };

  const generatedTableSelector = '#pc-fitment-transposed-table-wrapper';

  const renderTransposedFitmentTable = () => {
    const applications = document.querySelector('#Applications');
    const sourceTable = document.querySelector('#bc-applications');
    const wrapper = document.querySelector('#fitmentApplicationsWrapper');

    if (!applications || !sourceTable || !wrapper) return;

    const existingTable = wrapper.querySelector(generatedTableSelector);

    if (existingTable) {
      existingTable.remove();
    }

    wrapper.classList.remove('pc-fitment-transposed-ready');

    const sourceRows = Array.from(sourceTable.querySelectorAll('tr'));
    const headerRow = sourceRows.find((row) => row.querySelector('th'));
    const dataRows = sourceRows.filter((row) => row.querySelector('td'));

    if (!headerRow || !dataRows.length) return;

    const headers = Array.from(headerRow.querySelectorAll('th')).map((header) =>
      header.textContent.trim()
    );

    const rowValues = dataRows.map((row) =>
      Array.from(row.querySelectorAll('td')).map((cell) =>
        cell.textContent.trim()
      )
    );

    const tableWrapper = document.createElement('div');
    tableWrapper.id = 'pc-fitment-transposed-table-wrapper';
    tableWrapper.className = 'pc-fitment-transposed-table-wrapper';

    const transposedTable = document.createElement('table');
    transposedTable.id = 'pc-fitment-transposed-table';
    transposedTable.className = 'pc-fitment-transposed-table';
    transposedTable.setAttribute(
      'aria-label',
      'Compatibility table with vehicle details shown by row'
    );

    const tableBody = document.createElement('tbody');

    headers.forEach((header, columnIndex) => {
      const transposedRow = document.createElement('tr');

      const rowLabel = document.createElement('th');
      rowLabel.scope = 'row';
      rowLabel.textContent = labelMap[header] || header;
      transposedRow.appendChild(rowLabel);

      rowValues.forEach((values) => {
        const cell = document.createElement('td');
        cell.textContent = values[columnIndex] || '—';
        transposedRow.appendChild(cell);
      });

      tableBody.appendChild(transposedRow);
    });

    transposedTable.appendChild(tableBody);
    tableWrapper.appendChild(transposedTable);
    wrapper.appendChild(tableWrapper);
    wrapper.classList.add('pc-fitment-transposed-ready');
  };

  let renderTimer;

  const scheduleTransposeRender = () => {
    window.clearTimeout(renderTimer);

    renderTimer = window.setTimeout(() => {
      renderTransposedFitmentTable();
    }, 150);
  };

  const isGeneratedTableChange = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return false;

    return (
      node.matches(generatedTableSelector) ||
      Boolean(node.closest(generatedTableSelector))
    );
  };

  renderTransposedFitmentTable();

  const fitmentObserver = new MutationObserver((mutations) => {
    const fitmentChanged = mutations.some((mutation) => {
      const target =
        mutation.target.nodeType === Node.ELEMENT_NODE
          ? mutation.target
          : mutation.target.parentElement;

      // Ignore our own table being added/removed, preventing a render loop.
      if (target?.closest(generatedTableSelector)) return false;

      const sourceTableChanged = Boolean(target?.closest('#bc-applications'));

      const relevantElementWasAdded = Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          !isGeneratedTableChange(node) &&
          (node.matches('#Applications, #bc-applications') ||
            node.querySelector('#Applications, #bc-applications'))
      );

      return sourceTableChanged || relevantElementWasAdded;
    });

    if (fitmentChanged) {
      scheduleTransposeRender();
    }
  });

  fitmentObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// PCFITMENT FILTERS

(() => {
  const mobileBreakpoint = window.matchMedia('(max-width: 749px)');

  const filterState = {
    Year: '',
    Make: '',
    Model: ''
  };

  const labelMap = {
    BodyNumDoors: 'Doors',
    BodyType: 'Body type'
  };

  const getFitmentData = () => {
    const sourceTable = document.querySelector('#bc-applications');

    if (!sourceTable) return null;

    const sourceRows = Array.from(sourceTable.querySelectorAll('tr'));
    const headerRow = sourceRows.find((row) => row.querySelector('th'));
    const dataRows = sourceRows.filter((row) => row.querySelector('td'));

    if (!headerRow || !dataRows.length) return null;

    const headers = Array.from(headerRow.querySelectorAll('th')).map((header) =>
      header.textContent.trim()
    );

    const records = dataRows.map((row) => {
      const values = Array.from(row.querySelectorAll('td')).map((cell) =>
        cell.textContent.trim()
      );

      const fields = {};

      headers.forEach((header, index) => {
        fields[header] = values[index] || '';
      });

      return {
        row,
        values,
        fields
      };
    });

    return {
      sourceTable,
      headers,
      records
    };
  };

  const getUniqueValues = (records, field) => {
    return [
      ...new Set(
        records
          .map((record) => record.fields[field])
          .filter(Boolean)
      )
    ].sort((a, b) =>
      a.localeCompare(b, undefined, { numeric: true })
    );
  };

  const setSelectOptions = (select, values, placeholder, selectedValue) => {
    select.innerHTML = '';

    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = placeholder;
    select.appendChild(defaultOption);

    values.forEach((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      option.selected = value === selectedValue;
      select.appendChild(option);
    });

    select.disabled = values.length === 0;
  };

  const recordMatches = (record) => {
    return Object.entries(filterState).every(([field, selectedValue]) => {
      return !selectedValue || record.fields[field] === selectedValue;
    });
  };

  const renderMobileTransposedTable = (headers, records) => {
    const fitmentWrapper = document.querySelector('#fitmentApplicationsWrapper');

    if (!fitmentWrapper) return;

    const existingTable = fitmentWrapper.querySelector(
      '#pc-fitment-transposed-table-wrapper'
    );

    if (existingTable) {
      existingTable.remove();
    }

    fitmentWrapper.classList.remove('pc-fitment-transposed-ready');

    if (!mobileBreakpoint.matches) return;

    const tableWrapper = document.createElement('div');
    tableWrapper.id = 'pc-fitment-transposed-table-wrapper';
    tableWrapper.className = 'pc-fitment-transposed-table-wrapper';

    if (!records.length) {
      const emptyMessage = document.createElement('p');
      emptyMessage.className = 'pc-fitment-transposed-empty';
      emptyMessage.textContent =
        'No fitments match the filters you selected.';

      tableWrapper.appendChild(emptyMessage);
      fitmentWrapper.appendChild(tableWrapper);
      fitmentWrapper.classList.add('pc-fitment-transposed-ready');
      return;
    }

    const transposedTable = document.createElement('table');
    transposedTable.className = 'pc-fitment-transposed-table';
    transposedTable.setAttribute(
      'aria-label',
      'Filtered compatibility table'
    );

    const tableBody = document.createElement('tbody');

    headers.forEach((header, columnIndex) => {
      const transposedRow = document.createElement('tr');

      const rowLabel = document.createElement('th');
      rowLabel.scope = 'row';
      rowLabel.textContent = labelMap[header] || header;

      transposedRow.appendChild(rowLabel);

      records.forEach((record) => {
        const cell = document.createElement('td');
        cell.textContent = record.values[columnIndex] || '—';
        transposedRow.appendChild(cell);
      });

      tableBody.appendChild(transposedRow);
    });

    transposedTable.appendChild(tableBody);
    tableWrapper.appendChild(transposedTable);
    fitmentWrapper.appendChild(tableWrapper);
    fitmentWrapper.classList.add('pc-fitment-transposed-ready');
  };

  const refreshFitments = () => {
    const fitmentData = getFitmentData();
    const filterBar = document.querySelector('[data-fitment-filters]');

    if (!fitmentData || !filterBar) return;

    const { headers, records } = fitmentData;

    const yearSelect = filterBar.querySelector(
      '[data-fitment-filter="Year"]'
    );
    const makeSelect = filterBar.querySelector(
      '[data-fitment-filter="Make"]'
    );
    const modelSelect = filterBar.querySelector(
      '[data-fitment-filter="Model"]'
    );
    const count = filterBar.querySelector('[data-fitment-count]');

    const years = getUniqueValues(records, 'Year');

    if (filterState.Year && !years.includes(filterState.Year)) {
      filterState.Year = '';
      filterState.Make = '';
      filterState.Model = '';
    }

    const recordsForMake = records.filter(
      (record) =>
        !filterState.Year || record.fields.Year === filterState.Year
    );

    const makes = getUniqueValues(recordsForMake, 'Make');

    if (filterState.Make && !makes.includes(filterState.Make)) {
      filterState.Make = '';
      filterState.Model = '';
    }

    const recordsForModel = recordsForMake.filter(
      (record) =>
        !filterState.Make || record.fields.Make === filterState.Make
    );

    const models = getUniqueValues(recordsForModel, 'Model');

    if (filterState.Model && !models.includes(filterState.Model)) {
      filterState.Model = '';
    }

    setSelectOptions(yearSelect, years, 'Year', filterState.Year);
    setSelectOptions(makeSelect, makes, 'Make', filterState.Make);
    setSelectOptions(modelSelect, models, 'Model', filterState.Model);

    const filteredRecords = records.filter(recordMatches);

    records.forEach((record) => {
      record.row.style.display = recordMatches(record) ? '' : 'none';
    });

    count.textContent =
      filteredRecords.length === records.length
        ? `${records.length.toLocaleString()} compatible fitments`
        : `Showing ${filteredRecords.length.toLocaleString()} of ${records.length.toLocaleString()} fitments`;

    filterBar.hidden = false;

    renderMobileTransposedTable(headers, filteredRecords);
  };

  const initializeFilterEvents = () => {
    const filterBar = document.querySelector('[data-fitment-filters]');

    if (!filterBar || filterBar.dataset.initialized === 'true') return;

    filterBar.dataset.initialized = 'true';

    filterBar.addEventListener('change', (event) => {
      const field = event.target.dataset.fitmentFilter;

      if (!field) return;

      filterState[field] = event.target.value;

      if (field === 'Year') {
        filterState.Make = '';
        filterState.Model = '';
      }

      if (field === 'Make') {
        filterState.Model = '';
      }

      refreshFitments();
    });

    filterBar
      .querySelector('[data-fitment-reset]')
      .addEventListener('click', () => {
        filterState.Year = '';
        filterState.Make = '';
        filterState.Model = '';

        refreshFitments();
      });
  };

  let refreshTimer;

  const scheduleRefresh = () => {
    window.clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(() => {
      initializeFilterEvents();
      refreshFitments();
    }, 150);
  };

  initializeFilterEvents();
  scheduleRefresh();

  const fitmentObserver = new MutationObserver((mutations) => {
    const fitmentChanged = mutations.some((mutation) => {
      return (
        mutation.target.nodeType === 1 &&
        mutation.target.closest('#Applications')
      );
    });

    if (fitmentChanged) {
      scheduleRefresh();
    }
  });

  fitmentObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  mobileBreakpoint.addEventListener('change', scheduleRefresh);
})();


// PC FITMENT, Change "Fits Your" to "Potential Fit"

  // (() => {
  //   const updateFitmentMessage = () => {
  //     document.querySelectorAll('.dv-fit-msg').forEach((message) => {
  //       if (message.dataset.potentialMatchUpdated === 'true') return;

  //       const icon = message.querySelector('.nagds-check');

  //       if (icon) {
  //         icon.textContent = 'i';
  //         icon.classList.add('fitment-potential-match-icon');
  //         icon.setAttribute('aria-hidden', 'true');
  //       }

  //       Array.from(message.childNodes).forEach((node) => {
  //         if (node.nodeType === Node.TEXT_NODE) {
  //           node.nodeValue = node.nodeValue.replace(
  //             /Fits\s+Your/i,
  //             'Potential match for your'
  //           );
  //         }
  //       });

  //       message.classList.add('fitment-potential-match');
  //       message.dataset.potentialMatchUpdated = 'true';
  //     });
  //   };

  //   document.addEventListener('DOMContentLoaded', updateFitmentMessage);

  //   const observer = new MutationObserver(updateFitmentMessage);

  //   observer.observe(document.body, {
  //     childList: true,
  //     subtree: true
  //   });
  // })();

  
// Script to transpose table on My Garage Page

  (function () {
    var garage = document.getElementById("garagevehicle");

    if (!garage) {
      return;
    }

    var observer;
    var rebuildTimer;

    function observeGarage() {
      if (!observer) {
        observer = new MutationObserver(function () {
          window.clearTimeout(rebuildTimer);
          rebuildTimer = window.setTimeout(buildMobileGarage, 50);
        });
      }

      observer.observe(garage, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    /*
     * Send clicks from the mobile Actions row to the corresponding
     * controls in the original table.
     */
    function forwardActions(mobileCell, sourceCell) {
      var selector = "a, button, .clsGaragetd2";

      mobileCell.addEventListener(
        "click",
        function (event) {
          var mobileControl = event.target.closest(selector);

          if (!mobileControl || !mobileCell.contains(mobileControl)) {
            return;
          }

          var mobileControls = Array.prototype.slice.call(
            mobileCell.querySelectorAll(selector)
          );

          var sourceControls = sourceCell.querySelectorAll(selector);
          var controlIndex = mobileControls.indexOf(mobileControl);

          if (controlIndex < 0 || !sourceControls[controlIndex]) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          sourceControls[controlIndex].click();
        },
        true
      );
    }

    function buildMobileGarage() {
      /*
       * Pause observation while rebuilding so the generated mobile
       * table doesn't cause an endless rebuild loop.
       */
      if (observer) {
        observer.disconnect();
      }

      var existingMobileCard =
        garage.querySelector(".garage-mobile-card");

      if (existingMobileCard) {
        existingMobileCard.remove();
      }

      var sourceTable =
        garage.querySelector("#garage-applications");

      var headerRow =
        sourceTable && sourceTable.tHead
          ? sourceTable.tHead.rows[0]
          : null;

      var sourceBody =
        sourceTable && sourceTable.tBodies.length
          ? sourceTable.tBodies[0]
          : null;

      /*
       * The garage table may be loaded after the page. Continue
       * watching until it becomes available.
       */
      if (!headerRow || !sourceBody) {
        observeGarage();
        return;
      }

      var headers =
        Array.prototype.slice.call(headerRow.cells);

      var vehicles =
        Array.prototype.slice
          .call(sourceBody.rows)
          .filter(function (row) {
            return row.cells.length > 0;
          });

      if (!headers.length || !vehicles.length) {
        observeGarage();
        return;
      }

      var card = document.createElement("div");
      card.className = "garage-mobile-card";

      var hint = document.createElement("div");
      hint.className = "garage-mobile-hint";
      hint.innerHTML =
        "<span>Swipe right to see more compatible vehicles</span>" +
        '<span class="garage-mobile-hint__arrow" aria-hidden="true">&rarr;</span>';

      var scroll = document.createElement("div");
      scroll.className = "garage-mobile-scroll";
      scroll.setAttribute("tabindex", "0");
      scroll.setAttribute("role", "region");
      scroll.setAttribute("aria-label", "Saved vehicles");

      var mobileTable = document.createElement("table");
      mobileTable.className = "garage-mobile-table";

      var mobileBody = document.createElement("tbody");

      /*
       * Each original header becomes a row label.
       * Each original vehicle row becomes a vehicle column.
       */
      headers.forEach(function (header, fieldIndex) {
        var mobileRow = document.createElement("tr");

        var label = document.createElement("th");
        label.setAttribute("scope", "row");
        label.textContent = header.textContent.trim();

        mobileRow.appendChild(label);

        vehicles.forEach(function (vehicle) {
          var sourceCell = vehicle.cells[fieldIndex];

          var mobileCell = sourceCell
            ? sourceCell.cloneNode(true)
            : document.createElement("td");

          /* Prevent duplicate element IDs. */
          mobileCell.removeAttribute("id");

          mobileCell
            .querySelectorAll("[id]")
            .forEach(function (element) {
              element.removeAttribute("id");
            });

          /*
           * The final original column is Actions, so it becomes
           * the final row in the transposed table.
           */
          if (
            sourceCell &&
            fieldIndex === headers.length - 1
          ) {
            forwardActions(mobileCell, sourceCell);
          }

          mobileRow.appendChild(mobileCell);
        });

        mobileBody.appendChild(mobileRow);
      });

      mobileTable.appendChild(mobileBody);
      scroll.appendChild(mobileTable);
      card.appendChild(hint);
      card.appendChild(scroll);
      garage.appendChild(card);

      observeGarage();
    }

    observeGarage();
    buildMobileGarage();
  })();